import http from '../common/http-common';
import { DTOPermiso } from '../../Componest/Catalogos/CatPermisos/DTO/DTOPermiso';
import { DTOPermisoNotificacion } from '../../Componest/Catalogos/CatPermisos/DTO/DTOPermisoNotificacion';

class CatPermisos {
  
  GetPermisosPorEmpleado(numEmpleado: string) {
    return http.get<DTOPermiso[]>(
      `/Catalogos/CatalogoPermisos/GetObtenerPermisos/${numEmpleado}`
    );
    }

 
  PosInsertarPermiso(DTOPermiso: DTOPermiso) {
    return http.post<DTOPermiso[]>(
      `/Catalogos/CatalogoPermisos/PostInsertarPermisos`,
      DTOPermiso, {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );


  }


  PutEstadoPermiso(id: number, nuevoEstado: string, permisoConSueldo: boolean, observaciones: string) {
  return http.put<DTOPermiso[]>(
    `/Catalogos/CatalogoPermisos/PutEstadoPermiso`, 
    null, 
    {
      params: {
        id: id.toString(),
        nuevoEstado: nuevoEstado,
        permisoConSueldo: permisoConSueldo.toString(),
        observaciones: observaciones
      },
      headers: {
        'Content-Type': 'application/json',
      },
    }
  ); 
}


async EditarPermisoNomina(ajuste: DTOPermiso & { IdUsuarioRegistro: number }) {
    return http.put<DTOPermiso>(
        `/Catalogos/CatalogoPermisos/PutEditarPermisoNomina`,
        ajuste,
        {
            headers: { 'Content-Type': 'application/json' }
        }
    );
}



DeletePermiso(id: number) {
  return http.delete<{ Message: string }>(
    `/Catalogos/CatalogoPermisos/EliminarPermisos/${id}`
  );
}

    


 EnviarCorreoPermiso(DTOPermisoNotificacion: DTOPermisoNotificacion) {
    return http.post(
      `/Catalogos/CatalogoPermisos/EnviarCorreoPermiso`,
      DTOPermisoNotificacion,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  EnviarCorreoRH(permiso: DTOPermiso) {
  return http.post('/Catalogos/CatalogoPermisos/EnviarCorreoRRHH', permiso);
}






getAllSoPermisos(fechaInicio : string, FechaFin: string , FiltroTipo: string)
    {
      return http.get<DTOPermiso[]> (
        `/Catalogos/CatalogoPermisos/GetSoPermisos`, 
        {params: {fechaInicio: fechaInicio, FechaFin: FechaFin, FiltroTipo: FiltroTipo}
      }
      ); 
    }
  
}






export default new CatPermisos();
